import { areIntervalsOverlapping, endOfDay, startOfDay, Interval } from 'date-fns';

export const isDateOutsideRange = (sourceDate: Date, calendarRange: Interval) => {
    const sourceDateRange: Interval = { start: startOfDay(sourceDate), end: endOfDay(sourceDate) };
    return !areIntervalsOverlapping(sourceDateRange, calendarRange);
};
